<template>
  <div class="app_content" :style="{ 'padding-top': isApp ? '0' : '44px' }">
    <Headers v-if="!isApp"></Headers>
    <router-view class="router"></router-view>
  </div>
</template>

<script>
import Headers from './components/header.vue'
export default {
  components: {
    Headers
  },
  data() {
    return {
      isApp: true
    }
  },
  created() {
    this.isApp = localStorage.getItem('isApp') === '0'
  }
}
</script>

<style scoped>
.app_content {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f2f2f2;
  padding-top: 44px;
  box-sizing: border-box;
}

.router {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/operationViews/Layout/index.vue